// extracted by mini-css-extract-plugin
export var banner = "banner-module--banner--m08Q1";
export var btn = "banner-module--btn--6dQTH";
export var container = "banner-module--container--mfnf7";
export var img = "banner-module--img--edVZv";
export var imgOuter = "banner-module--imgOuter--ficJ+";
export var textBlock = "banner-module--textBlock--PeSYS";